import { makeAutoObservable } from 'mobx';
import React from 'react';
import { PopupsStackState } from 'src/AppState/PopupsStackState';
import { Common } from 'src/AppState/Common';
import { BonusCreationStore } from 'src/domains/casino/state/AppCasino/store/bonus-creation-store/BonusCreation.store';

export class BonusCreationsTableState {
    private common: Common;
    private loadingBonusRewardId: string | null = null;

    public constructor(common: Common) {
        makeAutoObservable(this);
        this.common = common;
    }

    public get isLoading(): string | null {
        return this.loadingBonusRewardId;
    }

    public handleDeleteBonusReward = (bonusCreationId: string, bonusCreationName: string): void => {
        const popupsStack = PopupsStackState.get(this.common);
        popupsStack.addPopup(`delete_bonus_reward_${bonusCreationId}`, {
            template: 'generic',
            title: 'Delete Bonus',
            titleClassName: 'text-center font-bold',
            message: (
                <p className='m-0'>
                    Are you certain you want to delete the draft bonus <strong>{bonusCreationName}</strong>? This action
                    is irreversible.
                </p>
            ),
            hasOverlay: true,
            cancel_label: 'Cancel',
            delete_label: 'Delete',
            isLoading: false,
            onDelete: async () => {
                const popup = popupsStack.topPopup;

                const setLoadingState = (state: boolean): void => {
                    if (popup !== undefined) {
                        popup.isLoading = state;
                    }
                };

                try {
                    setLoadingState(true);
                    this.loadingBonusRewardId = bonusCreationId;

                    const bonusCreationStore = BonusCreationStore.get(this.common);
                    await bonusCreationStore.deleteBonusCreation(bonusCreationId);
                } catch (error) {
                    console.error('Error deleting bonusReward:', error);
                } finally {
                    this.loadingBonusRewardId = null;
                    popupsStack.closePopupOnTop();
                }
            },
            onCancel: () => {
                this.loadingBonusRewardId = null;
                popupsStack.closePopupOnTop();
            },
        });
    };
}
